<template>
    <div class="products-distribution-table flex-grow-1">
        <div class="scroll-x">
            <b-table
                v-if="parcel.length > 0"
                id="packages-table"
                show-empty
                :class="['table-bordered']"
                :busy="$store.state.loading"
                :items="getParcels"
                :fields="[...fields, ...packageColumn]"
                :tbody-tr-class="tableClass"
                foot-clone>

                <div slot="itemInfo" slot-scope="data" class="font-weight-bold">
                    <!-- <div>ID: {{data.item.id}}</div> -->
                    <div>{{data.item.product.name}}</div>
                    <div>SKU: {{data.item.product.sku}}</div>
                    <div>FNSKU: {{data.item.product.fnsku}}</div>
                </div>

                <template slot="quantitySent"
                        slot-scope="data">
                    <b>{{data.value}}</b>
                </template>

                <template v-for="(field, index) in packageColumn"
                            :slot="field.key"
                            slot-scope="data">
                    <div :key="field.key" class="text-center">
                        <b>{{getProductQuantity(data.item.id, index)}}</b>
                    </div>
                </template>

                <div slot="FOOT_quantitySent"
                        slot-scope="data"
                        class="quantity-sent">
                    <span>Weight:</span>
                    <span>Dimensions:</span>
                </div>

                <template v-for="(field, index) in packageColumn"
                        :slot="'FOOT_'+ field.key"
                        slot-scope="data">
                    <div :key="field.key" class="h-100">
                        <div class="input-group-size">
                            <div>{{parcel[index].weight}}</div>
                        </div>
                        <div class="input-group-size">
                            <div>{{parcel[index].length}} x {{parcel[index].width}} x {{parcel[index].height}}</div>
                        </div>
                    </div>
                </template>

            </b-table>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ShipmentPackagesTable',
        props: {
            parcel: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                products: [],
                fields: [
                    {
                        key: 'itemInfo',
                        label: ''
                    },
                    {
                        key: 'quantitySent',
                        label: 'Shipping units'
                    }
                ]
            }
        },
        computed: {
            packageColumn() {
                let packages = new Array(this.parcel.length)
                packages = packages.fill(null).map((item, index) => {
                    item = {
                        key: `package${index + 1}`,
                        label: `Package ${index + 1}`
                    }
                    return item
                })
                return packages
            },
            getParcels() {
                return this.products
            }
        },
        created() {
            this.fetchProducts()
        },
        methods: {
            tableClass(item) {
                if (item !== null && item.status === 'danger') {
                    return 'table-danger'
                }
                return ''
            },
            fetchProducts() {
                this.$api('GET', this.$endpoints.incomesItems(this.$route.params.planId)).then(response => {
                    this.products = response
                }).finally(() => {
                    this.$emit('loadedProducts')
                })
            },
            getProductQuantity(productId, parcelIndex) {
                return this.parcel[parcelIndex].parcelInventory.filter(item => {
                    return item.inventory.id === productId
                })[0].inventory.quantitySent
            }
        }
    }
</script>

<style lang="scss">
    @import "~@/assets/style/utils/_variables.scss";

    .products-distribution-table {
        .alert {
            position: fixed;
            top: 30px;
            left: 15px;
            max-width: 520px;
            z-index: 9;
            ol {
                padding-left: 7px;
            }
        }
        .btn-reset-wrap {
            position: absolute;
            top: 0;
            right: 0;
            z-index: 1;
        }
        .btn-continue-wrap {
            position: absolute;
            left: 0;
            bottom: 30px;
            .btn-outline-user-primary {
                color: $text-default-color-user;
            }
        }
        .pt-reset {
            padding-top: 80px;
        }
        b {
            font-size: 14px;
            display: block;
        }
        .table {
            .btn-full {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                width: 100%;
                height: 100%;
                &:focus,
                &:not(:disabled):not(.disabled):active:focus,
                &:not(:disabled):not(.disabled).active:focus {
                    box-shadow: none;
                }
            }
            thead {
                th {
                    position: relative;
                    padding: 0 5px 0 5px;
                    text-align: center;
                    vertical-align: middle;
                    height: 40px;
                }
            }
            thead,
            tbody {
                tr {
                    td {
                        vertical-align: middle;
                        &:first-child {
                            width: 190px;
                            min-width: 190px;
                        }
                        &:not(:first-child):not(:last-child) {
                            position: relative;
                            text-align: center;
                            input {
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%)
                            }
                        }
                    }
                }
            }
            tfoot {
                th,
                td {
                    padding: 0;
                }
                .quantity-sent {
                    span {
                        display: flex;
                        height: 60px;
                        padding: 10px;
                        align-items: center;
                        justify-content: center;
                        font-weight: bold;
                        & + span {
                            border-top: 1px solid $gray-300;
                        }
                    }
                }
                .input-group-size {
                    height: 60px;
                }
                .input-group-size {
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    &:not(:first-child) {
                        border-top: 1px solid $gray-300;
                    }
                    padding-left: 10%;
                    padding-right: 10%;
                    span {
                        padding: 0 5px;
                    }
                    &__length {
                        text-align: right;
                    }
                    &__height {
                        text-align: left;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Inventory/Replenishment/Shipment/ShipmentPackagesTable.vue